import React from 'react';
import styled from 'styled-components';
import InvoiceTable from './invoices/InvoiceTable';
import PaymentMethodCard from './PaymentMethodCard';
import Card from './Card';

const Form = styled.form`
width: 65%;

@media (max-width:991px){
  width: 100%;
}
`;

export default function Billing() {
  return (
    <Form>
      <Card padding="20px 30px">
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <PaymentMethodCard />
          <InvoiceTable />
        </div>
      </Card>
    </Form>
  );
}
